module.exports = "<h2>Check Your Solar Lease / PPA Agreement</h2>\n\n<p>Does the information below match the information on the Solar Lease / PPA Agreeement?</p>\n\n<ul>\n\t<li>Lease / PPA Company is listed on the Lease / PPA Agreement</li>\n\t<li>Property Address</li>\n\t<li>Total Amount</li>\n</ul>\n\n<p class=\"closing-note\">All uploaded documents will be reviewed by our closing team.</p>";


//////////////////
// WEBPACK FOOTER
// ./src/app/appDetail/documents/uploadDocumentsModal/solarLeaseAgreementChecklistTemplate.html
// module id = 561
// module chunks = 1